import { render } from "./productCard.vue?vue&type=template&id=017fb47d"
import script from "./productCard.vue?vue&type=script&lang=js"
export * from "./productCard.vue?vue&type=script&lang=js"

import "./productCard.vue?vue&type=style&index=0&id=017fb47d&lang=scss"
script.render = render

export default script